"use client";

import { c as _c } from "react/compiler-runtime";
import { useRouter } from "next/navigation";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { HERO_SLIDES } from "../../_constants/heroSlides";
import MaxWidth from "@/app/(main_app)/_components/MaxWidth";
import ProgressiveImage from "../../_components/global/ProgressiveImage";
import { inhomzEvents } from "../../_lib/events";
import { useInhomzTrack } from "../../_hooks/useInhomzTrack";
export default function DesignIdeasLanding() {
  const $ = _c(11);
  const router = useRouter();
  const track = useInhomzTrack();
  const bannerImage = HERO_SLIDES[0];
  let t0;
  if ($[0] !== router || $[1] !== track) {
    t0 = () => {
      track(inhomzEvents.designIdeas.BACK_CLICKED);
      router.push("/");
    };
    $[0] = router;
    $[1] = track;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleBack = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      backgroundColor: "var(--colorSecondarySecondaryContainer)",
      "&:hover": {
        backgroundColor: "var(--colorSurfaceSurface)",
        opacity: 0.9
      }
    };
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <ArrowBackIcon sx={{
      color: "var(--textPrimaryPrimary)"
    }} />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleBack) {
    t3 = <div className="absolute left-4 top-4 z-20 lg:left-8 lg:top-8"><IconButton onClick={handleBack} aria-label="Go back" sx={t1}>{t2}</IconButton></div>;
    $[5] = handleBack;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="relative h-[232px] w-full overflow-hidden md:h-[300px] lg:order-2 lg:h-full lg:w-1/2"><ProgressiveImage src={bannerImage.src} alt={bannerImage.alt} priority={true} className="object-cover" sizes="(min-width: 1024px) 50vw, 100vw" /></div>;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="mx-auto flex max-w-[560px] flex-col items-center gap-3 px-6 py-4 text-center md:gap-4 md:py-10 lg:order-1 lg:mx-0 lg:h-full lg:w-1/2 lg:max-w-none lg:items-start lg:justify-center lg:px-16 lg:py-0 lg:text-left"><h1 className="m3-headline-medium text-[--textPrimaryPrimary]">Design Ideas for Your Home</h1><p className="m3-body-medium text-[--textSecondarySecondary] md:m3-title-large">From modern to classic, find a look you love for every room.</p></div>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t3) {
    t6 = <section className="relative w-full bg-[--colorSurfaceSurface] lg:bg-[--colorWarningWarning]"><MaxWidth padding="p-0"><div className="relative lg:flex lg:h-[380px] lg:items-stretch">{t3}{t4}{t5}</div></MaxWidth></section>;
    $[9] = t3;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
}